import mediaQuery from "@utils/mediaQuery";
import { ReactNode } from "react";
import styled from "styled-components";

interface Props {
  children?: ReactNode;
  onClick?: () => void;
}

const Container = styled.button`
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  line-height: 25.6px;
  text-decoration-line: underline;
  color: var(--text-link);

  &:hover {
    text-decoration-line: none;
  }

  ${mediaQuery("tablet")`
    font-size: var(--font-size-2xl);
    line-height: 28.8px;
`}
`;

const TextButton = ({ children, onClick }: Props) => {
  return <Container onClick={onClick}>{children}</Container>;
};

export default TextButton;
